import { call, put, takeLatest } from 'redux-saga/effects'
import { navigate } from '@reach/router'

import * as levelUpApi from '../apiModules/levelUp'
import * as levelUpModule from '../modules/levelUp'

// utils
import { setLocalStorageValues } from 'utils/localStorageManager'

function* fetchCourses({ payload }) {
  try {
    const result = yield call(levelUpApi.fetchCourses, payload)
    yield put(levelUpModule.fetchCoursesSuccess(result))
  } catch (err) {
    yield put(levelUpModule.fetchCoursesFailure(err))
  }
}

function* fetchCourseCategories({ payload }) {
  try {
    const result = yield call(levelUpApi.fetchCourseCategories, payload)
    yield put(levelUpModule.fetchCourseCategoriesSuccess(result))
  } catch (err) {
    yield put(levelUpModule.fetchCourseCategoriesFailure(err))
  }
}

function* fetchCourseCollections({ payload }) {
  try {
    const result = yield call(levelUpApi.fetchCourseCollections, payload)
    yield put(levelUpModule.fetchCourseCollectionsSuccess(result))
  } catch (err) {
    yield put(levelUpModule.fetchCourseCollectionsFailure(err))
  }
}

function* fetchGrowthGuides({ payload }) {
  try {
    const result = yield call(levelUpApi.fetchGrowthGuides, payload)
    yield put(levelUpModule.fetchGrowthGuidesSuccess(result))
  } catch (err) {
    yield put(levelUpModule.fetchGrowthGuidesFailure(err))
  }
}

function* registerForLevelUp({ payload }) {
  try {
    const result = yield call(levelUpApi.registerForLevelUp, payload)
    yield put(levelUpModule.registerForLevelUpSuccess(result))

    yield setLocalStorageValues(result)
    navigate('/dashboard')
  } catch (err) {
    yield put(levelUpModule.registerForLevelUpFailure(err))
  }
}

export const levelUpSagas = [
  takeLatest(levelUpModule.REGISTER_FOR_LEVEL_UP, registerForLevelUp),
  takeLatest(levelUpModule.FETCH_COURSES, fetchCourses),
  takeLatest(levelUpModule.FETCH_COURSE_CATEGORIES, fetchCourseCategories),
  takeLatest(levelUpModule.FETCH_COURSE_COLLECTIONS, fetchCourseCollections),
  takeLatest(levelUpModule.FETCH_GROWTH_GUIDES, fetchGrowthGuides),
  takeLatest(levelUpModule.REGISTER_FOR_LEVEL_UP, fetchGrowthGuides)
]
